import React from 'react';
import { Briefcase } from 'lucide-react';

/**
 * "Our Learners Now Work At" — premium logo marquee for instant trust.
 * Logos via Wikipedia / official brand SVG mirrors.
 */
const logos = [
  { name: 'Google',    src: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg' },
  { name: 'Adobe',     src: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Adobe_Corporate_Wordmark.svg' },
  { name: 'Meta',      src: 'https://upload.wikimedia.org/wikipedia/commons/0/05/Meta_Platforms_Inc._logo.svg' },
  { name: 'Amazon',    src: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg' },
  { name: 'TCS',       src: 'https://upload.wikimedia.org/wikipedia/commons/b/b1/Tata_Consultancy_Services_old_logo.svg' },
  { name: 'Accenture', src: 'https://upload.wikimedia.org/wikipedia/commons/c/cd/Accenture.svg' },
  { name: 'Deloitte',  src: 'https://upload.wikimedia.org/wikipedia/commons/1/15/Deloitte_Logo.png' },
  { name: 'Wipro',     src: 'https://upload.wikimedia.org/wikipedia/commons/a/a0/Wipro_Primary_Logo_Color_RGB.svg' },
  { name: 'Infosys',   src: 'https://upload.wikimedia.org/wikipedia/commons/9/95/Infosys_logo.svg' }
];

const LogoWall = () => (
  <section data-testid="logo-wall" className="py-14 px-4 bg-gradient-to-b from-white to-gray-50 border-y border-gray-200">
    <div className="container mx-auto max-w-6xl">
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-full px-4 py-1.5 mb-3">
          <Briefcase className="w-4 h-4 text-blue-600" />
          <span className="text-xs font-bold text-blue-700 uppercase tracking-widest">Our Learners Now Work At</span>
        </div>
        <h2 className="text-2xl md:text-3xl font-black text-gray-900">
          5000+ Students Trained &middot; <span className="text-blue-700">Placed at Global Brands</span>
        </h2>
      </div>

      <div className="relative overflow-hidden">
        {/* Edge fade masks */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-white to-transparent z-10"></div>
        <div className="pointer-events-none absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-white to-transparent z-10"></div>

        <div className="flex gap-12 md:gap-20 animate-marquee-left items-center" style={{ width: 'max-content' }}>
          {[...logos, ...logos].map((l, i) => (
            <img
              key={i}
              src={l.src}
              alt={l.name}
              className="h-7 md:h-10 object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition flex-shrink-0"
              loading="lazy"
              data-testid={`brand-logo-${l.name.toLowerCase()}`} decoding="async" fetchPriority="high" />
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default LogoWall;
